/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rag_Priority_LabelInputs */



/**
* | output |
* | --- |
* | "Prioritise internal sources" |
*
* @param {Rag_Priority_LabelInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const rag_priority_label = /** @type {((inputs?: Rag_Priority_LabelInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rag_Priority_LabelInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Interne Quellen bevorzugen")
	return /** @type {LocalizedString} */ ("Prioritise internal sources")
});